const {PRICE_TYPE} = require("./RentOptionConstant");

class OptionBase {

    constructor({
                    name = '',
                    priceBase = PRICE_TYPE.FLAT_FEE,
                    priceValue = 0
                } = {}) {
        this.name = name;
        this.priceBase = PRICE_TYPE[priceBase] || PRICE_TYPE.FLAT_FEE;
        this.priceValue = Number(priceValue);
    }

    static get PRICE_TYPE() {
        return PRICE_TYPE
    }

    static compare(a = {}, b = {}) {
        return (new OptionBase(a)).priceValue - (new OptionBase(b)).priceValue;
    }

    addPrice(priceBase = 0) {
        switch (this.priceBase) {
            case PRICE_TYPE.PERCENTAGE_BASED:
                return priceBase * (this.priceValue - 1);
            case PRICE_TYPE.FLAT_FEE:
                return this.priceValue;
            default:
                return 0;
        }
    }

    toFirestore() {
        return {
            name: this.name,
            priceBase: this.priceBase,
            priceValue: this.priceValue,
        }
    }

    isSame(obj = {}){
        return JSON.stringify(obj) === JSON.stringify(this)
    }
}

module.exports = OptionBase;